import { Container } from 'react-bootstrap'

function Testimonials() {
  return <Container>testimonials coming soon</Container>
}

export default Testimonials
